// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_94-4";
export var collapsed = "_94-1";
export var headerBar = "_94-0";
export var leftHeaderContent = "_94-3";
export var subjectContainer = "_94-2";